import * as React from 'react';
const CustomDnbUnderMaintenance = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
    <g data-name="Layer 2">
      <g fill="#b3b3b3" data-name="Layer 1">
        <path d="M7.9 9.06a3 3 0 0 1-.5.11 2.6 2.6 0 0 1-.4 0 2.7 2.7 0 0 1-.7-.09 3 3 0 0 1-.5-.17 2.6 2.6 0 0 1-.44-.23A3 3 0 0 1 5.2 3.8V6L7 7l1.8-1V3.8a3 3 0 0 1-.44 5.07 3 3 0 0 1-.46.19" />
        <path
          fillRule="evenodd"
          d="M7 14a7 7 0 1 0-7-7 7 7 0 0 0 7 7m.4-1.8v-2H7a4 4 0 0 1-.7-.07v2.07a.5.5 0 0 1-1 0V9.82A4 4 0 0 1 4.6 3a1 1 0 0 1 1.05-.1 1 1 0 0 1 .55.9v1.61l.8.45.8-.45V3.8A1 1 0 0 1 9.4 3a4 4 0 0 1-1 6.94v2.26a.5.5 0 0 1-1 0"
        />
      </g>
    </g>
  </svg>
);
export default CustomDnbUnderMaintenance;
